import { render, staticRenderFns } from "./AuthResetPasswordForm.vue?vue&type=template&id=2bde0bcb"
import script from "./AuthResetPasswordForm.vue?vue&type=script&lang=js"
export * from "./AuthResetPasswordForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-api/api.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bde0bcb')) {
      api.createRecord('2bde0bcb', component.options)
    } else {
      api.reload('2bde0bcb', component.options)
    }
    module.hot.accept("./AuthResetPasswordForm.vue?vue&type=template&id=2bde0bcb", function () {
      api.rerender('2bde0bcb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/AuthResetPasswordForm.vue"
export default component.exports